(function () {
  var ROOT_SELECTOR = '[data-advanced-timeline]';
  var LIST_SELECTOR = '.advanced-timeline__list';
  var PROGRESS_SELECTOR = '.advanced-timeline__progress';
  var ITEM_SELECTOR = '.advanced-timeline__item';

  function init(root) {
    var list = root.querySelector(LIST_SELECTOR);
    var progressEl = root.querySelector(PROGRESS_SELECTOR);
    if (!list || !progressEl) return;

    var animationType = root.getAttribute('data-animation') || 'fade-in';
    var threshold = parseFloat(root.getAttribute('data-threshold')) || 0.3;

    function updateProgress() {
      var rect = list.getBoundingClientRect();
      var vh = window.innerHeight;
      var top = rect.top;
      var height = rect.height;
      if (top > vh) {
        root.style.setProperty('--timeline-progress', '0');
        return;
      }
      if (top + height < 0) {
        root.style.setProperty('--timeline-progress', '1');
        return;
      }
      var p = (vh - top) / (vh + height);
      root.style.setProperty('--timeline-progress', String(Math.max(0, Math.min(1, p))));
    }

    window.addEventListener('scroll', updateProgress, { passive: true });
    window.addEventListener('resize', updateProgress);
    updateProgress();

    var items = root.querySelectorAll(ITEM_SELECTOR);
    if (items.length === 0 || animationType === 'none') return;

    var visibleClass = 'is-visible--' + animationType;

    function reveal(el) {
      if (el.classList.contains(visibleClass)) return;
      el.classList.remove('advanced-timeline__item--hidden');
      el.classList.add(visibleClass);
    }

    if (typeof IntersectionObserver !== 'undefined') {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) reveal(entry.target);
          });
        },
        { rootMargin: '0px', threshold: threshold }
      );
      items.forEach(function (el) { observer.observe(el); });
    } else {
      function checkReveal() {
        var vh = window.innerHeight;
        items.forEach(function (el) {
          var r = el.getBoundingClientRect();
          if (r.top < vh * (1 - threshold)) reveal(el);
        });
      }
      window.addEventListener('scroll', checkReveal, { passive: true });
      checkReveal();
    }
  }

  document.querySelectorAll(ROOT_SELECTOR).forEach(init);
})();
